<template>
  <div id="view">
    <div class="image-section" id="img-1">
      <imageContainer class="image"
                      :imageName="'SZY_9755'"
                      :width="'100%'"
                      :height="'100vh'"></imageContainer>
      <h1 class="title">Nyitott<br>Gyárak<br>Hétvégéje</h1>
      <div @click="goToSection('#opendays')" class="arrow white">
        <arrow-svg></arrow-svg>
      </div>
    </div>
    <div id="opendays">
      <div class="decoration"></div>
      <div class="content">
        <ul class="od-nav">
          <li>
            <router-link :to="`/companies/${year}`">{{companies}}</router-link>
          </li>
          <li>
            <router-link :to="`/programs/${year}`">Programok</router-link>
          </li>
          <li v-if="year === '2019'">
            <router-link :to="`/extra-programs/${year}`">Kísérő Programok</router-link>
          </li>
        </ul>
        <h2>Nyitott gyárak hétvégéje</h2>
        <div v-html="intro"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import imageContainer from './../components/imageContainer.vue'
  import arrowSvg from './../components/arrow.vue'
  import { scrollToSection } from '../utils'
  import { openDaysIntro } from '../utils/text'


  export default {
    name: 'openDays',
    components: {
      imageContainer,
      arrowSvg
    },
    computed: {
      theme() {
        return this.$store.getters['theme/getCurrentTheme']
      },
      year() {
        return this.$route.params.year
      },
      companies() {
        return this.year === '2019' ? 'Csatlakozó cégek' : 'Látogatható helyszínek'
      },
      intro() {
        return openDaysIntro[this.year]
      }
    },
    methods: {
      goToSection (selector) {
        scrollToSection(selector)
      }
    },
    created() {
      this.$store.dispatch('theme/getTheme', this.year);
    },
    watch: {
      year: function(year, prevYear) {
        this.year = year;
        this.$store.dispatch('theme/getTheme', this.year);
      }
    }
  }
</script>

<style scoped>
  #view {
    position: relative;
  }

  .od-nav {
    position: absolute;
    top: 0;
    right: 10px;
    display: flex;
    list-style: none;
    padding: 0;
  }

  .od-nav li a {
    margin: 0 15px;
    font-size: 20px;
    font-weight: 600;
    text-transform: uppercase;
    color: var(--colorB);
  }

  .image-section {
    position: relative;
    width: 100%;
    font-size: 0;
  }

  .image {
    opacity: 0.8;
  }

  .title {
    position: absolute;
    left: 50%;
    top: 20vh;
    margin: 0 0 10px;
    font-size: 120px;
    color: var(--colorA);
    text-transform: uppercase;
    text-shadow: 2px 2px white;
    transform: translateX(-50%);
  }


  .arrow {
    position: absolute;
    bottom: 7vh;
    left: calc(50% - 15px);
    width: 30px;
    height: 30px;
    padding: 5px;
    font-size: 36px;
    color: var(--colorA);
    cursor: pointer;
    z-index: 2;
    border: 2px solid var(--colorA);
    box-sizing: border-box;
  }

  #opendays {
    position: relative;
    min-height: 100vh;
    padding: 60px 40px;
    border: 10px solid var(--colorB);
    box-sizing: border-box;
  }

  #opendays h2 {
    position: absolute;
    min-height: 60px;
    height: auto;
    top: 0;
    left: 0;
    padding: 7px 60px 0;
    margin-top: 0;
    margin-bottom: 30px;
    background-color: var(--colorB);
    color: white;
    align-items: center;
  }

  .content {
    width: 66%;
    max-width: 960px;
    padding-top: 60px;
    text-align: left;
  }

  .decoration {
    position: absolute;
    width: calc(100vw / 7);
    height: 70vh;
    top: 30vh;
    right: 0;
    background-color: var(--colorA);
    opacity: 0.76;
    z-index: -1;
  }

  #opendays a,
  #opendays a:visited {
    color: var(--colorB);
  }

  #opendays a:hover {
    text-decoration: underline;
  }


  @media (max-width: 768px) {
    .title {
      font-size: 15vh;
    }
  }

  @media (max-width: 600px) {
   .title {
      top: 45vh;
      font-size: 9vh;
    }

    #opendays {
      padding: 60px 30px;
      height: auto;
    }

    #opendays h2 {
      padding-bottom: 10px;
      padding-left: 30px;
      font-size: 21px;
    }

    .content {
      width: 100%;
      padding-top: 20px;
    }

    .decoration {
      display: none;
    }
  }

</style>
